import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgb-game-nav',
  templateUrl: './game-nav.component.html',
})
export class GameNavComponent {
  @Input() routeLink: string;
  @Input() isRulesEnabled: boolean = false;
}
